export default __webpack_public_path__ + "static/media/express_plan_delivery@3x.7d314db6.png";